import { Dialog, type DialogProps } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import './travel-customization.styles.css';

const SecondaryModal = (props: DialogProps) => {
	return (
		<Dialog
			{...props}
			pt={{
				root: () => ({
					className: classNames(
						'tc-modal-top tc-modal-bottom tablet:!max-w-[calc(100vw-6rem)]',
						props.pt?.root,
					),
				}),
				header: {
					className: classNames(
						'tc-modal-header',
						'tc-modal-top',
						'tc-secondary-modal',
						props.pt?.header,
					),
				},
				content: {
					className: classNames(
						'tc-secondary-modal',
						props.pt?.content,
					),
				},
				footer: {
					className: classNames(
						'tc-modal-bottom',
						'tc-secondary-modal',
						props.pt?.footer,
					),
				},
			}}
		/>
	);
};

export default SecondaryModal;
